import { generatedProseConfig } from '@/lib/contexts/prose-config.generated';
import styles from './Prose.module.css';

import type { FunctionComponent } from 'react';
import type { TypeProseProps } from './types';

/**
 * El componente prose da estilos al texto rico que
 * se recibe desde un CMS.
 */
export const Prose: FunctionComponent<TypeProseProps> = ({
  as: HTMLTag = 'div',
  html,
  className = '',
  style,
}: TypeProseProps) => (
  <HTMLTag
    className={`prose max-w-full text-inherit ${styles['c-prose']} ${generatedProseConfig.customBullet ? styles['c-prose--bullet'] : ''} ${className}`}
    style={style}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

Prose.displayName = 'Prose';
